import React from "react";

import { getCountryFlag } from "components/Screens/CommonUtils";

import "./CountryCard.scss";

function CountryCard({ country = "", policies = 0, employees = 0, onClick = null }) {
  return (
    <div className="country-card" onClick={() => onClick?.(country)}>
      <div className="mb-075">{getCountryFlag(country, 24, 24)}</div>
      <div className="heading-h5-semibold color-text-heading-primary">{country}</div>
      <div className="para-body-s-regular color-text-body-primary">
        {policies} policies (applies to {employees} employees)
      </div>
    </div>
  );
}

export default CountryCard;
